export const config = {
  bucketName: 'hc-influencer-uploads',
  dirName: 'store',
  region: 'us-east-1',
  accessKeyId: 'AKIA3UMWN4BPYY34TM6M',
  secretAccessKey: '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',
  s3Url: 'https://hc-influencer-uploads.s3.amazonaws.com',
}